import { Box, Typography } from '@material-ui/core'

import VisitAvailabilityLink from 'routes/highschools/components/VisitAvailabilityLink'

import { highSchool } from './types'

const HighSchoolInfo = ({ highSchool, header }: { highSchool: highSchool; header?: boolean }) => {
  if (header) {
    return (
      <Box
        maxWidth={200}
        display="flex"
        flexDirection="column"
        gridGap={8}
      >
        <Typography variant="body1">{highSchool.name}</Typography>
        {highSchool.nextVisitDate && (
          <Typography variant="body2">
            <VisitAvailabilityLink
              highSchool={{
                id: highSchool.id,
                name: highSchool.name,
                nextVisitDate: highSchool.nextVisitDate,
              }}
            />
          </Typography>
        )}
      </Box>
    )
  }
  return null
}
export default HighSchoolInfo
